export default "__VITE_ASSET__7_$TPztB__"